import React, { useEffect } from 'react'
import { IContact } from '../../../../../service/interfaces/contacts'
import { CallBlockSvg, CallSVG, FillStartSVG, PinSvg, StarSVG, UnPinSvg } from '../../../../../components/IconSvg'
import { CSpinner } from '@coreui/react'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { useSelector } from 'react-redux'

const Possibilities = ({ item, updateContact, updateContactPending, handleBlock }:
    { item: IContact, updateContact: Function, updateContactPending: boolean, handleBlock: Function }) => {
    const [states, setStates] = CustomValuesHook({ selectedItem: undefined })
    const updateContactSuccess = useSelector((state: any) => state.contactReducer.updateContactSuccess)

    useEffect(() => {
        if (updateContactSuccess && states.selectedItem === item) {
            setStates({ selectedItem: undefined });
        }
    }, [updateContactSuccess])

    return (<div className='d-flex align-items-center contact-possibilities'>
        {!updateContactPending || states.selectedItem !== item ?
            <>
                <span className='spn-pin mx-1'
                    onClick={() => {
                        setStates({ selectedItem: item });
                        updateContact({ ...item, isPin: !item.isPin })
                    }} >
                    {item.isPin ? <PinSvg fill='#1E72C9' width={20} height={20} /> : <UnPinSvg width={20} height={20} />}
                </span>
                <span className='spn-star' onClick={() => {
                    setStates({ selectedItem: item });
                    updateContact({ ...item, isStar: !item.isStar });
                }} >
                    {item.isStar ? <FillStartSVG /> : <StarSVG />}
                </span>
                <span className='spn-block mx-1'
                    title='مشخص کردن کاربری که تمایل ندارید با آن تماس حاصل کنید.این وضعیت به عنوان اطالع رسانی.
                .ست و دسترسی تماس شما با شخص مسدود نخواهد شد'
                    onClick={() => {
                        setStates({ selectedItem: item });
                        handleBlock(item.contactId, !item.isInBlackList);
                    }}
                >
                    {!item.isInBlackList
                        ? <CallSVG styles={undefined} /> : <CallBlockSvg />}
                </span>
                <span className='spn-color' style={{ backgroundColor: item.color !== 'Empty' ? item.color : '#fff' }} ></span>
            </> : updateContactPending && states.selectedItem === item ? <CSpinner size="sm" /> : ''
        }


    </div>)
}

export default Possibilities